import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Calendar, ArrowRight, Mail, ExternalLink } from 'lucide-react';
export function AznAlahah() {
  const authorArticles = [{
    id: 1,
    title: 'New Study Reveals Link Between Gut Microbiome and Cognitive Function',
    excerpt: 'Our latest research uncovers significant correlations between specific gut bacteria populations and cognitive performance metrics in adults.',
    date: 'June 15, 2024',
    category: 'research',
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80'
  }, {
    id: 6,
    title: 'Microbiome Testing: What You Need to Know',
    excerpt: 'A guide to understanding microbiome testing methods, their accuracy, and how to interpret results.',
    date: 'January 28, 2024',
    category: 'education',
    image: 'https://images.unsplash.com/photo-1579154341098-e4e158cc7f55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80'
  }, {
    id: 8,
    title: 'The Future of Personalized Nutrition Through Microbiome Analysis',
    excerpt: 'How understanding your unique gut microbiome composition could transform dietary recommendations and health outcomes.',
    date: 'November 12, 2023',
    category: 'research',
    image: 'https://images.unsplash.com/photo-1563304997-7868d0f9e6f7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80'
  }];
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1040" data-mp="21kytlpgq2t3w">
      <Header data-id="element-1041" data-mp="3i08pnk2v1gv5" />
      <main className="flex-grow" data-id="element-1042" data-mp="3hzqlm19yhyco">
        {/* Profile Header */}
        <section className="bg-navy-50 py-16" data-id="element-1043" data-mp="3d1p0zbwvtqz3">
          <div className="container mx-auto px-4" data-id="element-1044" data-mp="3d0vw6ghhhbjl">
            <div className="max-w-5xl mx-auto" data-id="element-1045" data-mp="2aoj4cpgcp622">
              <div className="flex flex-col md:flex-row items-center md:items-start gap-8" data-id="element-1046" data-mp="2anr8ddiud6b9">
                <div className="w-32 h-32 md:w-48 md:h-48 overflow-hidden rounded-full border-4 border-white shadow-md" data-id="element-1047" data-mp="2fm12rlwqs2vt">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ehAQ8Bo9qatnBDWC5pLTdX/kokk.jpg" alt="Azn Alahah" className="w-full h-full object-cover" data-id="element-1048" data-mp="2jpqtagwz8ujh" />
                </div>
                <div className="text-center md:text-left md:flex-1" data-id="element-1049" data-mp="1w0ehrae6gae0">
                  <h1 className="text-3xl md:text-4xl font-bold text-navy-800 mb-2" data-id="element-1050" data-mp="20ypsrog7kqxt">
                    Azn Alahah
                  </h1>
                  <p className="text-teal-600 text-lg font-medium mb-4" data-id="element-1051" data-mp="25py2kllgaebi">
                    Chief R&D Officer
                  </p>
                  <div className="max-w-2xl" data-id="element-1052" data-mp="187y194a38qgt">
                    <p className="text-navy-700 mb-6" data-id="element-1053" data-mp="1d83o875exosk">
                      Microbiome scientist with over 5 years of experience in
                      pharmaceutical research and wellness science. Leads
                      research and development at the California Institute for
                      Microbiome Research (CalMiR).
                    </p>
                    <div className="flex flex-wrap justify-center md:justify-start gap-4" data-id="element-1054" data-mp="rpl804ulc8c7">
                      <a href="mailto:azn.alahah@calmir.org" className="flex items-center text-navy-700 hover:text-teal-600 transition-colors" data-id="element-1055" data-mp="rrxla4peluix">
                        <Mail size={18} className="mr-2" data-id="element-1056" data-mp="d0fb4nj86u7h" />
                        Contact
                      </a>
                      <a href="https://www.linkedin.com/in/aznalahah" target="_blank" rel="noopener noreferrer" className="flex items-center text-navy-700 hover:text-teal-600 transition-colors" data-id="element-1057" data-mp="823xs2tq21ki">
                        <ExternalLink size={18} className="mr-2" data-id="element-1058" data-mp="1z4851tmertvm" />
                        LinkedIn
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Bio Section */}
        <section className="py-12" data-id="element-1059" data-mp="1ubnb8s3i5gs3">
          <div className="container mx-auto px-4" data-id="element-1060" data-mp="1uam1qs24x2ch">
            <div className="max-w-5xl mx-auto" data-id="element-1061" data-mp="1feo8bhjlic3y">
              <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-1062" data-mp="1fduz89x5zain">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1063" data-mp="1kfbwlvgfweuh">
                  About Azn Alahah
                </h2>
                <div className="text-navy-700 space-y-4" data-id="element-1064" data-mp="16gcaaugegc1h">
                  <p data-id="element-1065" data-mp="1bcsxnmfrymdi">
                    Azn Alahah is the Chief R&D Officer of the California
                    Institute for Microbiome Research (CalMiR), which was
                    established in 2024 to bridge the gap between academic
                    research and real-world health applications in the field of
                    microbiome science.
                  </p>
                  <p data-id="element-1066" data-mp="3awzbvgkefsbu">
                    With over 5 years of experience in pharmaceutical research
                    and wellness science, Azn recognized a critical gap in the
                    wellness industry: the lack of pharmaceutical-grade research
                    rigor applied to microbiome science and consumer health
                    products. His vision for CalMiR was to create an independent
                    research institute that would stand apart from commercial
                    interests, applying the highest standards of scientific
                    inquiry to validate what works, debunk what doesn't, and
                    ensure that microbiome science benefits all communities.
                  </p>
                  <p data-id="element-1067" data-mp="2d979m86hi0xe">
                    Azn's research focuses on the gut-brain axis, microbiome
                    modulation through diet and lifestyle interventions, and the
                    development of evidence-based protocols for microbiome
                    restoration after disruption. His work has been published in
                    leading scientific journals and presented at international
                    conferences.
                  </p>
                  <p data-id="element-1068" data-mp="r4ru84olaavp">
                    Prior to joining CalMiR, Azn worked in pharmaceutical
                    research, where he specialized in the development of
                    microbiome-targeted therapeutics. He holds a Ph.D. in
                    Microbiology and Immunology from Stanford University and
                    completed postdoctoral training at the University of
                    California, San Francisco.
                  </p>
                  <p data-id="element-1069" data-mp="1etb3onjdktpd">
                    As a passionate advocate for scientific integrity in the
                    wellness industry, Azn regularly speaks at conferences and
                    educational events about the importance of evidence-based
                    approaches to microbiome health. Through CalMiR, he is
                    committed to advancing truth in microbiome science and
                    making these discoveries accessible to all.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Articles Section */}
        <section className="py-12 bg-navy-50" data-id="element-1070" data-mp="3n0o961ag90rw">
          <div className="container mx-auto px-4" data-id="element-1071" data-mp="3n0emonom5bqy">
            <div className="max-w-5xl mx-auto" data-id="element-1072" data-mp="3i1be4t9fcne8">
              <h2 className="text-2xl font-bold text-navy-800 mb-8" data-id="element-1073" data-mp="3i2mtzrg59llp">
                Articles by Azn Alahah
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1074" data-mp="3d8s4269y4ae6">
                {authorArticles.map(article => <div key={article.id} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-1075" data-mp="9mjnvq4ok4zh">
                    <div className="h-48 overflow-hidden" data-id="element-1076" data-mp="39cw1og30qc64">
                      <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-1077" data-mp="39bb6co8vqp77" />
                    </div>
                    <div className="p-6" data-id="element-1078" data-mp="34eb28ivlbwiq">
                      <div className="flex items-center text-sm text-navy-500 mb-2" data-id="element-1079" data-mp="3s3vnx9j4p7vp">
                        <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full text-xs font-medium" data-id="element-1080" data-mp="xccbs5gxdwc">
                          {article.category.charAt(0).toUpperCase() + article.category.slice(1)}
                        </span>
                        <span className="mx-2" data-id="element-1081" data-mp="3o07e0k70y07a">•</span>
                        <Calendar size={14} className="mr-1" data-id="element-1082" data-mp="27n918c2gyni4" />
                        <span data-id="element-1083" data-mp="27q53gclcnycd">{article.date}</span>
                      </div>
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1084" data-mp="2co6lcu71hrm9">
                        {article.title}
                      </h3>
                      <p className="text-navy-600 mb-4 line-clamp-3" data-id="element-1085" data-mp="204jbq536bn9q">
                        {article.excerpt}
                      </p>
                      <a href={article.id === 1 ? '/blog/gut-microbiome-cognition' : article.id === 6 ? '/blog/microbiome-testing' : article.id === 8 ? '/blog/personalized-nutrition' : `/blog/${article.id}`} className="text-teal-600 hover:text-teal-700 font-medium flex items-center" data-id="element-1086" data-mp="2e2pt8antfan8">
                        Read more
                        <ArrowRight size={16} className="ml-1" data-id="element-1087" data-mp="12n1174vpflfk" />
                      </a>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </section>
        {/* Research Interests */}
        <section className="py-12" data-id="element-1088" data-mp="1wax6k5i48q4p">
          <div className="container mx-auto px-4" data-id="element-1089" data-mp="1wbyj6ees5koj">
            <div className="max-w-5xl mx-auto" data-id="element-1090" data-mp="1rbkkhmz2jn36">
              <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1091" data-mp="1ra9bn8qrnp57">
                Research Interests
              </h2>
              <div className="grid md:grid-cols-2 gap-6" data-id="element-1092" data-mp="1ibfenh9iwwr4">
                <div className="bg-navy-50 p-6 rounded-lg" data-id="element-1093" data-mp="1icyx9einjjw2">
                  <h3 className="text-xl font-bold text-navy-800 mb-3" data-id="element-1094" data-mp="1dk5qym7jc3hv">
                    Gut-Brain Axis
                  </h3>
                  <p className="text-navy-700" data-id="element-1095" data-mp="18me26126sxhw">
                    Investigating the bidirectional communication between the
                    gut microbiome and neurological function, with particular
                    focus on cognitive performance and mood regulation.
                  </p>
                </div>
                <div className="bg-navy-50 p-6 rounded-lg" data-id="element-1096" data-mp="ummq45v8dr6j">
                  <h3 className="text-xl font-bold text-navy-800 mb-3" data-id="element-1097" data-mp="369yfert82v13">
                    Microbiome Restoration
                  </h3>
                  <p className="text-navy-700" data-id="element-1098" data-mp="3a8yubz8kxdit">
                    Developing evidence-based protocols for restoring healthy
                    microbiome balance after disruption from antibiotics,
                    illness, or lifestyle factors.
                  </p>
                </div>
                <div className="bg-navy-50 p-6 rounded-lg" data-id="element-1099" data-mp="2mn0pgd5h7oql">
                  <h3 className="text-xl font-bold text-navy-800 mb-3" data-id="element-1100" data-mp="2rjirh59f98z8">
                    Dietary Influences
                  </h3>
                  <p className="text-navy-700" data-id="element-1101" data-mp="2whsj55vxtrg3">
                    Studying how specific dietary components and patterns impact
                    microbiome composition and function, with applications for
                    personalized nutrition.
                  </p>
                </div>
                <div className="bg-navy-50 p-6 rounded-lg" data-id="element-1102" data-mp="28s82wur658ai">
                  <h3 className="text-xl font-bold text-navy-800 mb-3" data-id="element-1103" data-mp="20sl64j4ys0ps">
                    Biomarker Development
                  </h3>
                  <p className="text-navy-700" data-id="element-1104" data-mp="1wqzzhfj0wio1">
                    Identifying and validating biomarkers that predict
                    microbiome health, therapeutic response, and clinical
                    outcomes for various interventions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1105" data-mp="1dtf7hzkyp3z7" />
    </div>;
}